module.exports = __webpack_public_path__ + "img/talk_7.a1af4e10.png";